import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { collection, doc, getDoc, onSnapshot } from 'firebase/firestore';
import { db } from '../firebase';
import Empty from './Empty';
import ListingCard from './ListingCard';

export default function SavedSheetContent({ user, onOpenListing }) {
  const [saved, setSaved] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!user) return undefined;
    return onSnapshot(collection(db, 'users', user.uid, 'saved'), async (snap) => {
      const rows = await Promise.all(
        snap.docs.map(async (x) => {
          const listing = await getDoc(doc(db, 'listings', x.id));
          return listing.exists() ? { id: listing.id, ...listing.data() } : null;
        }),
      );
      setSaved(rows.filter(Boolean));
      setLoading(false);
    });
  }, [user]);

  if (loading) return <div className="sheet-loading">Loading…</div>;
  if (!saved.length) {
    return (
      <Empty
        icon="bookmark"
        title="Nothing saved yet"
        body="Tap Save on a listing to keep it here."
      />
    );
  }

  return (
    <div className="listing-grid sheet-grid">
      {saved.map((item) =>
        onOpenListing ? (
          <button
            key={item.id}
            type="button"
            className="listing-card-button"
            onClick={() => onOpenListing(item.id)}
          >
            <ListingCard item={item} asDiv />
          </button>
        ) : (
          <ListingCard key={item.id} item={item} />
        ),
      )}
    </div>
  );
}

export function SavedPageFallback({ user }) {
  return (
    <section className="content-page">
      <div className="page-title">
        <h1>Saved</h1>
        <p>Keep track of the things you love.</p>
      </div>
      <SavedSheetContent user={user} />
      <p className="muted center-note">
        <Link to="/account">Back to account</Link>
      </p>
    </section>
  );
}
